const CHART_IMAGE_ID = 'chart-image';
const CHART_IMAGE_CONTAINER_ID = 'chart-image-container';
const CONTROL_BAR_UPPER_CONTAINER_ID = 'control-bar-upper-container';
const MODE_SPECIFIC_UI_ID = 'mode-specific-ui';
const CHARTS_DROPDOWN_MENU_TOGGLE_BUTTON_ID = 'charts-dropdown-menu-toggle-button';
const CHART_LIST_DROPDOWN_MENU_TOGGLE_BUTTON_ID = 'chart-list-dropdown-menu-toggle-button';
const OPTIONS_PLAY_CONTAINER_ID = 'options-play-container';
const SELECT_CHART_STYLE_BUTTON = 'select-chart-style-button';

export {
  CHART_IMAGE_ID,
  CHART_IMAGE_CONTAINER_ID,
  CONTROL_BAR_UPPER_CONTAINER_ID,
  MODE_SPECIFIC_UI_ID,
  CHARTS_DROPDOWN_MENU_TOGGLE_BUTTON_ID,
  CHART_LIST_DROPDOWN_MENU_TOGGLE_BUTTON_ID,
  OPTIONS_PLAY_CONTAINER_ID,
  SELECT_CHART_STYLE_BUTTON
};
